import React from "react"
import { FaPencilAlt } from "react-icons/fa"

const GoalReviewButton: React.FC<{
  enable: boolean
  onClick: () => void
}> = ({ enable, onClick }) => {
  return (
    <button
      className={`text-white bg-site-blue-dark bg-site-blue-dark px-4 text-sm 
                leading-none py-2 rounded-full flex items-center`}
      onClick={() => {
        if (enable) onClick()
      }}
    >
      <span>Review</span>
    </button>
  )
}

export default GoalReviewButton
